module.exports = __webpack_public_path__ + "img/logo.f544eb54.png";